import { graphql } from "@opensea/graphql"
import { ActivityEventFragment } from "./ActivityEvent.fragment"

export const ActivityFeedTypeIconFragment = graphql(
  `
    fragment ActivityFeedTypeIcon on Activity {
      __typename
      ...ActivityEvent
    }
  `,
  [ActivityEventFragment],
)
